<p>list-services works!</p>
